export const OPENING_COMPOSER_PLACEHOLDER =
  "Describe your symptoms, or type a scan…";
export const REPLY_COMPOSER_PLACEHOLDER = "Type your answer…";
export const COMPOSER_MAX_HEIGHT_PX = 132;
export const AI_CHAT_MESSAGE_DATA_PREFIX = "aiChatMessage";
export const STREAMING_MARKER_ATTR = "data-ai-chat-streaming";
const MILLISECONDS_PER_SECOND = 1000;
const STREAM_REPLY_TIMEOUT_SECONDS = 45;
export const STREAM_REPLY_TIMEOUT_MS =
  STREAM_REPLY_TIMEOUT_SECONDS * MILLISECONDS_PER_SECOND;

export function resizeComposerField(
  field,
  maxHeightPx = COMPOSER_MAX_HEIGHT_PX
) {
  if (!field) {
    return;
  }
  field.style.height = "auto";
  field.style.height = `${Math.min(field.scrollHeight, maxHeightPx)}px`;
}

export function lastRowIsSettledAssistant(log) {
  const last = log?.lastElementChild;
  if (!last || typeof last.getAttribute !== "function") {
    return false;
  }
  if (last.hasAttribute(STREAMING_MARKER_ATTR)) {
    return false;
  }
  const data = last.getAttribute("x-data") || "";
  return data.includes(AI_CHAT_MESSAGE_DATA_PREFIX);
}

// Appending the user bubble fires the #messages observer before the assistant row exists, so the streaming marker alone
// would unlock the composer and let a later send supersede the in-flight job. Keep the lock until a stream node appears,
// a non-streamed notice lands, or the POST fails.
export function syncReplyInFlight({
  streamingInDom,
  awaitingAssistantReply,
  settledAssistantArrived,
} = {}) {
  if (streamingInDom) {
    return {
      replyInFlight: true,
      awaitingAssistantReply: false,
    };
  }

  if (settledAssistantArrived) {
    return {
      replyInFlight: false,
      awaitingAssistantReply: false,
    };
  }

  if (awaitingAssistantReply) {
    return {
      replyInFlight: true,
      awaitingAssistantReply: true,
    };
  }

  return {
    replyInFlight: false,
    awaitingAssistantReply: false,
  };
}

export function jsonHeaders(csrfToken) {
  return {
    "X-CSRF-Token": csrfToken || "",
    Accept: "application/json",
    "Content-Type": "application/json",
  };
}
